import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import Immutable from "community/immutable";
import "vendor/es6-promise";
import Module from "global/sparta-module-utility";
import spartaStyleUtility from "global/sparta-style-utility";
import Utility from "community/module-utils-utility";
import Cx from "modules/home-loans/services-home-loans-module/2.2.0/js/constants-services-home-loans-module";
import spartaTemplates from "modules/home-loans/services-home-loans-module/2.2.0/js/templates";
import "css!modules/home-loans/services-home-loans-module/2.2.0/css/services-home-loans-module.scss.css";
/**
 * @method eprofileSuccess
 */
export default {

  /**
   * @method HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS
   * @param {Object} payload
   */
  HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS ( payload ) {
    const route = { ...payload, route: 'mortgage', id: '#ratesTableFallbackModule' };
    payload = { ...route };
    dispatch.bind(this)( Cx.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS, payload);
  },

  /**
   * @method HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE
   * @param {Object} payload
   */
  HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE, { ...payload, route: 'mortgage', id: '#ratesTableFallbackModule' });
  },

  /**
   * @method HOME_LOANS_MORTGAGE_CALCULATOR_SUBMI
   */
  HOME_LOANS_MORTGAGE_CALCULATOR_SUBMIT ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_MORTGAGE_CALCULATOR_SUBMIT, payload);
  },

  /**
   * @method HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS
   */
  HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS, payload);
  },

  /**
   * @method HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE
   */
  HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE, payload);
  },

  /**
   * @method HOME_LOANS_REFINANCE_CALCULATOR_SUBMI
   */
  HOME_LOANS_REFINANCE_CALCULATOR_SUBMIT ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_REFINANCE_CALCULATOR_SUBMIT, payload);
  },
  
  /**
   * @method HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS
   */
  HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS, payload);
  },
  
  /**
   * @method HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE
   */
  HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE, payload);
  },

  /**
   * @method HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS
   * @param {Object} payload
   */
  HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS ( payload ) {
    const route = { ...payload, route: 'refinance', id: '#ratesTableFallbackModule' };
    payload = { ...route };
    dispatch.bind(this)( Cx.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS, payload);
  },

  /**
   * @method HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE
   * @param {Object} payload
   */
  HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE, { ...payload, route: 'refinance', id: '#ratesTableFallbackModule' });
  },

  /**
   * @method HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT
   */
  HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT, payload);
  },

  /**
   * @method HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS
   */
  HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS, payload);
  },

  /**
   * @method HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE
   */
  HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE, payload);
  },

  HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUCCESS ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUCCESS, payload );
  },

  HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_FAILURE ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_FAILURE, payload );
  },

  /**
   * @method HOME_LOANS_ZIP_CODE_LOCATOR_SUBMIT
   */
  HOME_LOANS_ZIP_CODE_LOCATOR_SUBMIT () {
    dispatch.bind(this)( Cx.HOME_LOANS_ZIP_CODE_LOCATOR_SUBMIT, {});
  },

  /**
   * @method HOME_LOANS_ZIP_CODE_LOCATOR_SUCCESS
   */
  HOME_LOANS_ZIP_CODE_LOCATOR_SUCCESS ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_ZIP_CODE_LOCATOR_SUCCESS, payload);
  },

  /**
   * @method HOME_LOANS_ZIP_CODE_LOCATOR_FAILURE
   */
  HOME_LOANS_ZIP_CODE_LOCATOR_FAILURE ( error ) {
    dispatch.bind(this)( Cx.HOME_LOANS_ZIP_CODE_LOCATOR_FAILURE, error);
  },

  /**
   * @method HOME_LOANS_GET_A_CALL_BACK_REQUEST_SUBMIT
   */
  HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT () {
    dispatch.bind(this)( Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT, {});
  },

  /**
   * @method HOME_LOANS_GET_A_CALL_BACK_REQUEST_SUCCESS
   */
  HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS, payload);
  },

  /**
   * @method HOME_LOANS_OVERVIEW_NEW_ZIP_CODE_SUBMIT
   * @param payload
   */
  HOME_LOANS_OVERVIEW_NEW_ZIP_CODE_SUBMIT ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_OVERVIEW_NEW_ZIP_CODE_SUBMIT, payload );
  },

  /**
   * @method HOME_LOANS_GET_A_CALL_BACK_REQUEST_FAILURE
   */
  HOME_LOANS_LEADS_CALL_REQUEST_FAILURE ( error ) {

    if ( error.error.responseJSON && error.error.responseJSON.fieldErrors ) {
      dispatch.bind(this)( Cx.HOME_LOANS_LEADS_CALL_VALIDATION_ERRORS, error.error.responseJSON.fieldErrors);
      return true;
    }

    dispatch.bind(this)( Cx.HOME_LOANS_LEADS_CALL_REQUEST_FAILURE, error);

  },

  HOME_LOANS_GENERIC_SUCCESS ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_GENERIC_SUCCESS, payload);
  },

  HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUCCESS ( payload ) {
    const route = { ...payload, route: false, id: '#ratesTableFallbackModule' };
    payload = { ...route };
    dispatch.bind(this)( Cx.HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUCCESS, payload);
  },

  HOME_LOANS_HOME_EQUITY_RATES_REQUEST_FAILURE ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_HOME_EQUITY_RATES_REQUEST_FAILURE, { ...payload, route: false, id: '#ratesTableFallbackModule' });
  },

  HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS ( payload ) {
    dispatch.bind(this)( Cx.HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS, payload );
  },

  HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE ( error ) {
    dispatch.bind(this)( Cx.HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE, error );
  }
}

/**
 * @method dispatch
 */
function dispatch ( action, payload ) {

  //console.groupCollapsed('Dispatching action: ', action);
  //  console.log(payload);
  //console.groupEnd();

    // This is a javascript dirty trick. The function passed to
    // setTimeout executes in a new execution context, and exceptions
    // thrown in that context do not bubble out to the calling context
    setTimeout( () => this.Events.pub( action, payload ), 0 );

}
